module.exports = __webpack_public_path__ + "img/leaf_3.174374a2.png";